import ReactPaginate from 'react-paginate'

import style from './Pagination.module.scss'

interface Props {
  totalResults?: number
  pageSize?: number
  onPageChange?: (page: number) => void
  currentPage?: number
}

export default function Pagination({ totalResults, pageSize, onPageChange, currentPage = 1 }: Props) {
  if (!totalResults || !pageSize) {
    return <></>
  }

  const pages = Math.ceil(totalResults / pageSize)

  function handlePageClick({ selected } : { selected: number }) {
    if (Number.isInteger(selected) && onPageChange) {
     onPageChange(selected + 1)
    }
  }

  return (
    <section>
      <ReactPaginate
        initialPage={currentPage - 1}
        pageCount={pages}
        onPageChange={handlePageClick}
        className={style.pagination}
        pageLinkClassName={style.paginationItemLink}
        activeLinkClassName={style.paginationItemLinkActive}
      />
    </section>
  )
}
